import React, {Component} from 'react'
import ConnectedComponent from '../../../../shared/connecter/ConnectedComponent'
import SimpleModalComponent from '../../../../shared/modal/SimpleModalComponent'
import {LevelContainer, ScoreContainer} from '../../containers/LevelContainer'
import {DiceScorePad, DeleteScoreKey} from './SharedLevelComponent'

class ScoreKey extends Component {
    triggerScore = () => {
        const {value} = this.props
        if (this.props.onChange) this.props.onChange(value)
    }

    render() {
        const {name} = this.props
        const size = this.props.size
        const className = `col-md-${size} col-sm-${size} col-xs-${size} text-center padkey`
        return (
            <div className={className} onClick={this.triggerScore}>
                {name}
            </div>
        )
    }
}


class ScorePad extends Component {

    triggerScore = (v) => {
        if (this.props.onChange)  this.props.onChange(v)
    }

    render() {
        const {value} = this.props.conf.config
        const dice = this.props.dice

        return (
            <div className="row">
                <div className="col-md-3 col-sm-3 col-xs-3 text-center"/>
                <div className="col-md-6 col-sm-6 col-xs-6">
                    <div className="row pad">
                        { !dice ? <ScoreKey onChange={this.triggerScore} value={0} name={'/'}/> : null }
                        <ScoreKey onChange={this.triggerScore} size={ !dice ? 4 : 12 } value={value} name={value}/>
                        { !dice ? <DeleteScoreKey size={4} onChange={this.triggerScore} value={'x'} name={''}/> : null }
                    </div>
                </div>
            </div>
        )
    }
}


class DiceScorePadWrapper extends Component {
    triggerScore = (v) => {
        if (this.props.onChange)  this.props.onChange(v)
    }

    render() {
        return (<DiceScorePad onChange={this.triggerScore}>
            <ScorePad dice={true} onChange={this.triggerScore} conf={this.props.conf}/>
        </DiceScorePad>)
    }
}

class ScoreComponent extends Component {

    constructor() {
        super()
        this.state = {
            edit: false
        }
    }

    triggerScore = (v) => {
        const {player, conf} = this.props
        if (this.props.onChange) this.props.onChange(player, conf, v)
        this.setState({
            edit: false
        })
    }

    editScore = () => {
        // const {player, conf} = this.props
        // const content = <ScorePad  onChange={this.triggerScore} conf={this.props.conf} />

        const {player, conf} = this.props
        // const content = mode === 'dices' ?
        //     <DiceScorePadWrapper onChange={this.triggerScore} conf={this.props.conf}/> :
        //     <ScorePad onChange={this.triggerScore} conf={this.props.conf}/>
        const content = <DiceScorePadWrapper onChange={this.triggerScore} conf={this.props.conf}/>

        return this.state.edit ?
            <SimpleModalComponent title={conf.config.name + ' pour ' + player.name } content={content}
                                  close={e=>this.toggleEditScore(false)}/> : null
    }

    toggleEditScore = (status) => {
        this.setState({
            edit: status !== 'undefined' ? status : !this.state.edit
        })
    }


    render() {
        const {player, conf} = this.props
        const _score = player.scoreBoard.find(o => o.id === conf.id)
        const score = _score ? _score.value : 0
        return (
            <ScoreContainer level={this.props.conf}>
                {this.editScore()}
                <span onClick={this.toggleEditScore}>{_score ? score ? score : '/' : ''}</span>
            </ScoreContainer>)
    }
}


export default class OfAKindLevelComponent extends ConnectedComponent {

    constructor() {
        super()
        this.subscribe('players')
    }

    saveScore = (player, level, v) => {
        const playerScoreBoard = this.store.players.get(player.id).get('scoreBoard').filter(s => s.id !== level.id)
        if (v !== 'x') {
            playerScoreBoard.push({id: level.id, value: v})
        }
        this.store.players.get(player.id).set('scoreBoard', playerScoreBoard)
    }

    render() {

        const level = this.props.level
        const scores = this.store.players.toJSON().map(player => {
            return <ScoreComponent mode={this.store.settings.get('mode')} onChange={this.saveScore} key={player.id}
                                   player={player} conf={level}/>
        })

        return (<LevelContainer bonus={level.config.bonus} className={this.props.className}
                                name={level.config.name}>{scores}</LevelContainer>)
    }
}


// WEBPACK FOOTER //
// ./src/game/level/components/types/FlushLevelComponent.jsx